import React from 'react';
import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap } from 'react-google-maps';
import MainMapWrapper from '../../../../containers/MainMapWrapper/MainMapWrapper';

export const mapApi = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCB-C2df0QoK2pJ1TnRGKXTOexFZDeHY3U&libraries=geometry,drawing,places';

const MapComponent = compose(
  withProps({
    googleMapURL: mapApi,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '400px' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(() => (
  <MainMapWrapper />
));

export default MapComponent;
